"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Accordion = _interopRequireDefault(require("../Accordion/Accordion"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _common = require("../../config/common");
var _DownloadCard = require("../cards/DownloadCard");
var _FragmentTooltip = _interopRequireDefault(require("./FragmentTooltip"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _string = require("../../utils/type-checks/string");
var _useQueryParam = _interopRequireDefault(require("../../utils/hooks/useQueryParam"));
var _content = require("../../config/content");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge");

/**
 * Component to load content fragments when building projects
 *
 * @visibleName Imported Content Fragment
 * @author Eric Shoemaker
*/
const ImportedContentFragment = props => {
  const {
      htmlElem = "div",
      id,
      type = _common.CONTENT_FRAGMENT_TYPE_DEFAULT,
      component,
      customComponentMap = {},
      options = {},
      ...rest
    } = props,
    domOptions = merge(options, _common.DOM_PURIFY_OPTIONS),
    ComponentMap = merge({
      Accordion: _Accordion.default,
      DownloadListItem: _DownloadCard.DownloadListItem,
      ImportedContentFragment: ImportedContentFragment
    }, customComponentMap),
    [userType] = (0, _useQueryParam.default)(_common.USER_TYPE_KEY),
    HTMLElem = htmlElem;
  let returnElem;

  // checks for passed through component string, otherwise renders regular html fragment.
  if ((0, _string.isStringOfLength)(component)) {
    try {
      switch (component) {
        case "accordion":
          returnElem = /*#__PURE__*/_react.default.createElement(ComponentMap.Accordion, _extends({}, rest, {
            customComponentMap: ComponentMap,
            fragmentArray: (0, _content.getAccordionContentArrayById)(id)
          }));
          break;
        case "downloadList":
          returnElem = (0, _content.getDownloadListArrayById)(id).map((fileItem, index) => /*#__PURE__*/_react.default.createElement(ComponentMap.DownloadListItem, _extends({}, fileItem, {
            customComponentMap: ComponentMap,
            key: `download__item__${id}_${index}`
          }, rest)));
          break;
        default:
          throw new Error(`Invalid component type component passed as ${component}.\nfragmentId: ${id}`);
      }
    } catch (err) {
      const params = new URLSearchParams({
        message: window.btoa(err.message),
        metaData: window.btoa(err.stack)
      });
      fetch(`${_common.URL_PUBLIC_REPORT}?${params}`);
    }
  } else {
    returnElem = /*#__PURE__*/_react.default.createElement(HTMLElem, _extends({}, rest, {
      dangerouslySetInnerHTML: {
        __html: _dompurify.default.sanitize((0, _content.getContentFragmentById)(id), domOptions)
      },
      "data-content-fragment-id": id,
      "data-content-fragment-type": type
    }));
  }
  if (userType === _common.USER_TYPE_AUTHOR) {
    returnElem = /*#__PURE__*/_react.default.createElement(_FragmentTooltip.default, {
      id: id,
      type: type
    }, component ? /*#__PURE__*/_react.default.createElement("div", null, returnElem) : returnElem);
  }
  return returnElem;
};

// Define propTypes;
ImportedContentFragment.propTypes = {
  /** String to be used to indicate which type of component */
  component: _propTypes.default.oneOf(["accordion", "downloadList"]),
  /** Optional custom component map for passing instance components */
  customComponentMap: _propTypes.default.objectOf(_propTypes.default.elementType),
  /** String to be used as HTML Element (Default Value: "div") */
  htmlElem: _propTypes.default.string,
  /** String to be output */
  id: _propTypes.default.string.isRequired,
  /** DOM Purify Options */
  options: _propTypes.default.object,
  /** String defining Content Fragment Type (Default Value: CONTENT_FRAGMENT_TYPE_DEFAULT) */
  type: _propTypes.default.oneOf([_common.CONTENT_FRAGMENT_TYPE_DEFAULT, _common.CONTENT_FRAGMENT_TYPE_TEST])
};

// Export component as default;
var _default = exports.default = ImportedContentFragment;